import {makeStyles} from '@material-ui/core/styles';

const ACTION_BUTTON_DIMENSIONS = {
  desktop: {
    button: 20,
    columnUnit: 30, // botón + padding real
  },
  tablet: {
    button: 40,
    columnUnit: 44, // botón + gap real
  },
};

const ACTION_COLUMN_PADDING = 8;

export const getActionColumnWidth = (
  maxButtons: number,
  isTablet: boolean,
): number => {
  const unit = isTablet
    ? ACTION_BUTTON_DIMENSIONS.tablet.columnUnit
    : ACTION_BUTTON_DIMENSIONS.desktop.columnUnit;

  return maxButtons * unit + ACTION_COLUMN_PADDING + 6; // 6 extra para evitar corte con el borde
};

export const useActionButtonStyles = makeStyles((theme) => ({
  /* =======================================================
   * Compact (desktop)
   * ======================================================= */
  compactButton: {
    width: ACTION_BUTTON_DIMENSIONS.desktop.button,
    height: ACTION_BUTTON_DIMENSIONS.desktop.button,
    marginRight: theme.spacing(1),
    color: '#4040a1',
  },

  compactEdit: {
    width: ACTION_BUTTON_DIMENSIONS.desktop.button,
    height: ACTION_BUTTON_DIMENSIONS.desktop.button,
    color: '#4040a1',
  },

  compactDelete: {
    width: ACTION_BUTTON_DIMENSIONS.desktop.button,
    height: ACTION_BUTTON_DIMENSIONS.desktop.button,
    color: '#bb2124',
  },

  compactContainer: {
    paddingRight: 5,
    paddingLeft: 5,
    float: 'left',
  },

  /* =======================================================
   * Touch / Tablet
   * ======================================================= */

  tabletButton: {
    width: ACTION_BUTTON_DIMENSIONS.tablet.button,
    height: ACTION_BUTTON_DIMENSIONS.tablet.button,
    margin: theme.spacing(0.25),
    color: '#1C4257',
    borderColor: '#1C4257',
    backgroundColor: 'rgba(21, 101, 192, 0.1)',
    border: '1px solid',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgba(21, 101, 192, 0.25)',
      borderColor: '#0D47A1',
    },
  },

  tabletIcon: {
    fontSize: 22,
  },

  tabletContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
}));
